"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DumpsterSizeTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.DumpsterSizeTransport = typebox_1.Type.Object({
    size: typebox_1.Type.Number(),
    type: typebox_1.Type.String(),
});
//# sourceMappingURL=dumpster-size-transport.js.map